import { render } from "./LabelContentDocumentTypeListWidget.vue?vue&type=template&id=818653f0&ts=true"
import script from "./LabelContentDocumentTypeListWidget.ts?vue&type=script&lang=ts&external"
export * from "./LabelContentDocumentTypeListWidget.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__